import React, {Component} from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import Loading from "@irati/ui/src/Loading"
import {groupQuestionsByDriver} from "@irati/insights/helpers/question"
import {H3} from "@irati/ui/src/Headings"
import authentication from "@irati/auth"
import {replacePlaceholders} from "@irati/insights/utils/string"

import Table, {Tr, Td} from "../../ui/SimpleTable"
import {Page} from "../../components/Layout"
import {listQuestions} from "../../graph/question"


class QuestionLibrary extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    schedule: PropTypes.object
  }


  constructor(props) {
    super(props)
    this.state = {
      load: this.getQuestions()
    }
  }

  getQuestions = () => {
    const {schedule} = this.props
    const params = {
      questionGroups: schedule.preferences.groupIds.join(","),
      withQuestionDriver: true
    }
    const load = listQuestions(params)
      .then((data) => {
        this.setState({
          questions: data
        })
      })
    return load
  }


  render() {
    const idNamespace = id("Question-Library", this.props, {force: true})
    const {questions, load} = this.state
    const questionsByDriver = groupQuestionsByDriver(questions, null, true)
    const placeholders = {
      tenant: authentication.userTenant().public_name
    }

    return (
      <Page id={idNamespace}>
        <Loading load={load}>
          <div id={idNamespace}>
            {questionsByDriver.map((driverQuestions) => (
              <div key={driverQuestions.driver.id}>
                <H3 base>
                  {driverQuestions.driver.name}
                </H3>
                <Table>
                  {driverQuestions.questions.map((question) => (
                    <Tr
                      id={id(question.id, idNamespace)}
                      key={question.id}>
                      <Td>{replacePlaceholders(question.text, placeholders)}</Td>
                    </Tr>
                  ))}
                </Table>
              </div>
            ))}
          </div>
        </Loading>
      </Page>
    )
  }
}

export default QuestionLibrary
